import { useState } from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useTheme } from '@mui/material/styles';
import { Sidebar, SIDEBAR_WIDTH } from './Sidebar';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  function handleMobileToggle() {
    setMobileOpen((prev) => !prev);
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Desktop: permanent sidebar */}
      {!isMobile && (
        <Sidebar variant="permanent" />
      )}

      {/* Mobile: temporary sidebar */}
      {isMobile && (
        <Sidebar
          variant="temporary"
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        {/* Mobile top AppBar */}
        {isMobile && (
          <AppBar
            position="sticky"
            elevation={0}
            sx={{
              bgcolor: 'background.paper',
              color: 'text.primary',
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open navigation"
                onClick={handleMobileToggle}
                sx={{ mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
              <RocketLaunchIcon sx={{ color: 'primary.main', fontSize: 22, mr: 1 }} />
              <Typography variant="h6" fontWeight="bold" noWrap>
                SaaS App
              </Typography>
            </Toolbar>
          </AppBar>
        )}

        {/* Page content */}
        <Box sx={{ flexGrow: 1 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}

// Re-export for convenience
export { SIDEBAR_WIDTH };
